"use strict";

require('../../layouts/web');
require('venobox');

var IpixPortfolio = function() {

    var initCarousels = function(e) {

        IpixJson.options.owlcarousel.margin = 25;
        $('.owl-products').owlCarousel(IpixJson.options.owlcarousel);
    }
    var loadMoreBtnClick = function() {
        $(".loadmore").click(function(e) {
            e.preventDefault();
            IpixPortfolio.loadMorePortfolio(true);
        });
    }

    var productSelect = function() {
        $(".product_select").change(function() {
            var selectedProducts = $(this).val();
            $('input[name="page"]').val(1);
            $('input[name="product_id"]').val(selectedProducts);
            IpixPortfolio.loadMorePortfolio(false);
        });
    };
    var serviceSelect = function() {
        $(".service_select").change(function() {
            var selectedServices = $(this).val();
            $('input[name="page"]').val(1);
            $('input[name="service_id"]').val(selectedServices);
            IpixPortfolio.loadMorePortfolio(false);
        });
    };
    return {
        init: function() {
            initCarousels();
            IpixPortfolio.loadMorePortfolio(false, "");
            loadMoreBtnClick();
            productSelect();
            serviceSelect()
        }
    }
}();

IpixUtil.onDOMContentLoaded(function() {
    IpixPortfolio.init();
});


IpixPortfolio.loadMorePortfolio = function(isMore) {

    var formData = $("#portfolioPaginateForm").serialize();
    $.ajax({
        url: $("#portfolioPaginateForm").attr("action"),
        type: 'GET',
        data: {

            formData: formData,
        },
        success: function(data) {
            if (isMore) {
                $("#portfolio-list-div").append(data.view);
                $("input[name='page']").val(parseInt(data.page) + parseInt(1));
            } else {

                $("#portfolio-list-div").html(data.view);
                $("input[name='page']").val(parseInt(data.page) + parseInt(1));
            }
            if (data.more == true) {
                $(".loadmore").show();
            } else {
                $(".loadmore").hide();
            }
            $('.venobox').venobox();
        },
    });
}

// $(function() {
//     const updateCount = function(select) {
//         let selectedOptions = select.select2("data");
//         let count = selectedOptions.length;

//         let container = select.next(".select2");

//         if (count > 0) {
//             container.addClass("options-selected");
//             container.find(".select2-selection__rendered").html(
//                 count + " Option Selected"
//             );

//         } else {
//             container.removeClass("options-selected");
//             container.find(".select2-selection__rendered").html("");
//         }

//         container.find(".select2-results__option input[type='checkbox']").each(function() {
//             let optionValue = $(this).closest("li").attr("data-value");
//             let isSelected = selectedOptions.some(option => option.id == optionValue);
//             $(this).prop("checked", isSelected);
//         });
//     };

//     $(".service_select, .product_select").select2({
//         closeOnSelect: false,
//         placeholder: "Service",
//         allowHtml: true,
//         allowClear: true,
//         tags: true,
//         templateResult: formatOption,
//     }).on("select2:select select2:unselect", function() {
//         updateCount($(this));
//     });

//     $(document).on('click', '.close-btn', function() {
//         let select = $(this).closest('.select2-container').prev('select');
//         select.val(null).trigger('change');
//     });

//     function formatOption(option) {
//         if (!option.id) {
//             return option.text;
//         }

//         let isSelected = option.element.selected || option.selected;
//         let checkbox = isSelected ? "checked" : "";
//         return $('<span><input type="checkbox" ' + checkbox + ' /> ' + option.text + '</span>');
//     }
// });